var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"d-flex flex-column",staticStyle:{"padding-right":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }